<template>
  <div>
    <DetailIndex :shipmentExpenseCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-shipment-expense',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
